import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { MAILING_LIST_PHONE_PATTERN } from '../utils/mailingListValidation';

const MailingListModal = ({
  open,
  closing = false,
  onClose,
  onSubmit,
  submitting = false,
  fullName,
  setFullName,
  email,
  setEmail,
  phone,
  setPhone,
  promotionalConsent,
  setPromotionalConsent,
  idPrefix = 'mail',
}) => {
  useEffect(() => {
    if (!open && !closing) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('mail-modal-open');
    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.classList.remove('mail-modal-open');
    };
  }, [open, closing]);

  if (!open && !closing) return null;

  const modal = (
    <div
      className={`mail-modal-backdrop${closing ? ' is-closing' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="Mailing list form"
    >
      <div className={`mail-modal-card${closing ? ' is-closing' : ''}`}>
        <button type="button" className="mail-modal-close" aria-label="Close form" onClick={onClose}>
          <svg className="mail-modal-close-icon" viewBox="0 0 15 15" fill="none" aria-hidden="true">
            <path d="M1.5 1.5L13.5 13.5M13.5 1.5L1.5 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>

        <div className="mail-modal-card-body">
          <div className="mail-modal-mobile-hero">
            <p className="mail-modal-mobile-kicker">Be the first</p>
            <p className="mail-modal-mobile-title">
              <span className="mail-modal-mobile-title-line">To access insider updates</span>
              <span className="mail-modal-mobile-title-line">from Neoterra Developments.</span>
            </p>
          </div>
          <div className="mail-modal-desktop-hero">
            <p className="mail-modal-desktop-kicker">Be the first</p>
            <p className="mail-modal-copy mail-modal-copy--desktop">
              <span className="mail-modal-desktop-line mail-modal-desktop-line--1">
                To access insider updates
              </span>
              <span className="mail-modal-desktop-line mail-modal-desktop-line--2">
                from Neoterra Developments
              </span>
            </p>
            <p className="mail-modal-desktop-lead">
              <span className="mail-modal-desktop-lead-line">
                Join our mailing list for exclusive news, updates, and
              </span>
              <span className="mail-modal-desktop-lead-line">
                special offers. Stay connected. Stay informed.
              </span>
            </p>
          </div>
          <p className="mail-modal-copy mail-modal-copy--mobile">
            Join our mailing list for exclusive news, updates, and special offers. Stay connected.
            Stay informed.
          </p>

          <form className="mail-modal-form" onSubmit={onSubmit} noValidate>
            <label htmlFor={`${idPrefix}-full-name`}>Full name</label>
            <input
              id={`${idPrefix}-full-name`}
              type="text"
              placeholder="John Doe"
              autoComplete="name"
              value={fullName}
              onChange={(ev) => setFullName(ev.target.value)}
              disabled={submitting}
              required
              minLength={2}
              maxLength={80}
            />

            <label htmlFor={`${idPrefix}-email`}>Email address</label>
            <input
              id={`${idPrefix}-email`}
              type="email"
              placeholder="john@example.com"
              autoComplete="email"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              disabled={submitting}
              required
              maxLength={120}
            />

            <label htmlFor={`${idPrefix}-phone`}>Phone number</label>
            <input
              id={`${idPrefix}-phone`}
              type="tel"
              placeholder="+97150162228"
              autoComplete="tel"
              inputMode="tel"
              pattern={MAILING_LIST_PHONE_PATTERN}
              title="Please enter a valid phone number."
              value={phone}
              onChange={(ev) => setPhone(ev.target.value)}
              disabled={submitting}
              required
              maxLength={20}
            />

            <label className="mail-modal-checkbox">
              <input
                type="checkbox"
                checked={promotionalConsent}
                onChange={(ev) => setPromotionalConsent(ev.target.checked)}
                disabled={submitting}
              />
              <span>
                I would like to receive promotional material from{' '}
                <span className="mail-modal-checkbox-brand">
                  Neoterra{' '}
                  <br className="mail-modal-checkbox-brand-br" aria-hidden="true" />
                  Developments.
                </span>
              </span>
            </label>

            <button type="submit" className="mail-modal-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;
  return createPortal(modal, document.body);
};

export default MailingListModal;
